import { useEffect, useState } from "react";
import { BASE_URL } from "../constants";
import { MdDelete, MdErrorOutline } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { FcPicture, FcVideoCall } from "react-icons/fc";
import ReactPlayer from 'react-player/lazy';
import { useNavigate } from "react-router-dom";
import { Switch } from '@headlessui/react'
import { FaYoutube } from "react-icons/fa";
import axios from 'axios';
import { getGrades, getSubjects } from "../utils";

const VideoForm = ({ video, handleFormAction }) => {
  const [formData, setFormData] = useState(video || {});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [deleted, setDeleted] = useState({ thumbnail: false, murl: false, lurl: false });
  const [constants, setConstants] = useState([]);
  const navigate = useNavigate();
  const [youtubeSrc, setYoutubeSrc] = useState(false);
  const vaildYoutubeLink = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/

  const required = {
    "title": "Video Title",
    "description": "Video Description",
    "subject_id": "Video Subject",
    "grade_id": "Video Grade",
    "thumbnail": "Cover Image (thumbnail)",
    "murl": "Medium Quality Source",
    "lurl": "High Quality Source",
  };

  useEffect(() => {
    const getConstants = async () => {
      const Grades = await getGrades();
      const Subjects = await getSubjects();

      setConstants({ Grades, Subjects });
    }

    constants.length == 0 && getConstants();
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError({})
    
    // check for missing required fields
    let missing = {};
    for (let key of Object.keys(required)) {
      if (!formData[key]) {
        missing[key] = `${required[key]} is required!`;
      }
    }

    if((missing.murl && ! missing.lurl) || (missing.lurl && ! missing.murl)) {
      delete missing.murl;
      delete missing.lurl;
    }

    if(missing.murl) missing.murl = `You have to supply at least one source (Medium / High) Quality`
    if(missing.lurl) missing.lurl = `You have to supply at least one source (Medium / High) Quality`

    if (Object.keys(missing).length !== 0) return setError(missing);
    
    if(youtubeSrc){
      let invalid = {};
      if (formData.murl && !vaildYoutubeLink.test(formData.murl)) invalid["murl"] = "Invalid Youtube Link!"
      if (formData.lurl && !vaildYoutubeLink.test(formData.lurl)) invalid["lurl"] = "Invalid Youtube Link!"

      if (Object.keys(invalid).length !== 0) return setError(invalid);
    }
    // make form request
    setLoading(true);
    try {
      const resObject = await handleFormAction(formData);
      setLoading(false);

      if(resObject.status == 200){
        navigate(`/dashboard/video`);
      } else {
        setError({ ...error, [e.target.id]: "Form submit failed! Please try again later.." });
      }
    } catch (error) {
      console.log(error);
      setError({...error, [e.target.id]: "Form submit failed! Please try again later.."});
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    })
  }

  const handleUpload = async (e) => {
    // reset error
    setError({ ...error, [e.target.id]: "" })

    // extarct file from event object
    const file = e.target.files[0];
    if (!file) {
      console.log("no file selected");
      return;
    }

    // validate file type
    let type = file.type.split("/")[0];

    if (e.target.id == 'thumbnail') {
      if (type !== "image") {
        setError({ ...error, thumbnail: "You have to choose image type for this field (e.g. jpg, png, etc..)" })
        e.target.value = null;
        return;
      }
    } else {
      if (type !== "video") {
        setError({ ...error, [e.target.id]: "You have to choose video type for this field (e.g. mp4)" })
        e.target.value = null;
        return;
      }
    }

    setLoading(true);
    const imageData = new FormData();
    imageData.append('file', file, file.name);

    try {
      const res = await axios.post(`${BASE_URL}/uploadFile.php`, imageData);
      const resObject = await res.data;
      setLoading(false);
      e.target.value = null;

      if (resObject.status == 200) {
        setFormData({ ...formData, [e.target.id]: resObject.data.url })
        setDeleted({ ...deleted, [e.target.id]: false });
      } else {
        setError({ ...error, [e.target.id]: "Upload failed! Please try again later.." });
      }
    } catch (error) {
      console.log(error);
      setError({...error, [e.target.id]: "Upload failed! Please try again later.."});
      setLoading(false);
      e.target.value = null;
    }
  }
  return (
    <section className="max-w-4xl page-container">
      <div className="flex flex-col gap-2 bg-gray-50 border-1 border-gray-400 shadow-lg rounded-lg px-4 py-8">
        <h1 className="mb-2 text-4xl font-bold text-center text-lightAqua">{`${video ? `Update ${video.title}` : "Add New Video"}`}</h1>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4" id="submit">
          {/* title */}
          <div className='flex flex-col'>
            <label htmlFor="title" className="text-lg font-semibold">{required['title']} *</label>
            <input type="text" id="title" className="paper-input-bar" value={formData.title || ""} placeholder="your video title" onChange={handleChange} />
            {
              error.title &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.title}
              </small>
            }
          </div>

          {/* description */}
          <div className='flex flex-col'>
            <label htmlFor="description" className="text-lg font-semibold">{required['description']} *</label>
            <textarea rows={4} id="description" className="paper-input-bar" value={formData.description || ""} placeholder="brief description of your video" onChange={handleChange} />
            {
              error.description &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.description}
              </small>
            }
          </div>

          <div className="flex gap-4">
            {/* subject_id */}
            <div className='flex flex-col w-full'>
              <select value={formData.subject_id || ""} id="subject_id" className="paper-input-bar" onChange={handleChange}>
                <option value="" disabled>Select Subject</option>
                <option value="-2" >All</option>
                {constants.Subjects?.map((subject, idx) => (
                  <option
                    key={idx}
                    value={subject.id}
                  >
                    {subject.title}
                  </option>
                ))}
              </select>
              {
                error.subject_id &&
                <small className='text-red-700 flex items-center gap-1'>
                  <MdErrorOutline /> {error.subject_id}
                </small>
              }
            </div>

            {/* grade_id */}
            <div className='flex flex-col w-full'>
              <select value={formData.grade_id || ""} id="grade_id" className="paper-input-bar" onChange={handleChange}>
                <option value="" disabled>Select Grade</option>
                {constants.Grades?.map((grade, idx) => (
                  <option
                    key={idx}
                    value={grade.id}
                  >
                    {grade.grade}
                  </option>
                ))}
              </select>
              {
                error.grade_id &&
                <small className='text-red-700 flex items-center gap-1'>
                  <MdErrorOutline /> {error.grade_id}
                </small>
              }
            </div>
          </div>

          {/* thumbnail */}
          <div className='flex flex-col w-full'>
            <span className="text-lg font-semibold">{required['thumbnail']} *</span>
            {
              formData.thumbnail && !deleted.thumbnail ?
                <div className="relative">
                  <img src={formData.thumbnail} alt="thumbnail" className="h-80 object-cover w-full rounded-lg" />
                  <div className="absolute bg-gray-800 bg-opacity-60 tailwind-hover-opacity flex items-center justify-center inset-0 rounded-lg">
                    {
                      loading ? <span className="loading loading-ring w-20 text-lightAqua" />
                        :
                        <>
                          <button type="button" className="rounded-full text-gray-50 hover:bg-red-500 p-2"><MdDelete fontSize={30} onClick={() => { setFormData({ ...formData, thumbnail: "" }); setDeleted({...deleted, thumbnail: true}) }} /></button>
                          <label htmlFor="thumbnail" className="rounded-full text-gray-50 hover:bg-blue-500 p-2 cursor-pointer"><FaEdit fontSize={30} /></label>
                        </>
                    }
                  </div>
                </div>
                :
                <label htmlFor='thumbnail' className="upload-container">
                  {
                    loading ?
                      <span className="loading loading-ring w-20 text-lightAqua" />
                      :
                      <>
                        <FcPicture fontSize={120} />
                        <span>Choose a thumbnail cover image</span>
                      </>
                  }
                </label>
            }

            <input disabled={loading} type="file" accept="image/*" className="hidden" id='thumbnail' onChange={handleUpload} />
            {
              error.thumbnail &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.thumbnail}
              </small>
            }
          </div>

          {/* youtube src inputs */}
          <div className="flex justify-between gap-4">
            <label className="text-2xl font-semibold" htmlFor="youtube_src">Insert video links directly from <span className="text-red-600">YouTube</span>?</label>
            <Switch
              checked={youtubeSrc}
              onChange={() => setYoutubeSrc(!youtubeSrc)}
              className={`${youtubeSrc ? 'bg-red-200 border-red-300' : 'bg-green-200 border-green-300'} flex h-8 w-[80px] items-center rounded-full border-1 shadow-lg`}
            >
              <span
                className={`${youtubeSrc && 'translate-x-[45px] rotate-0'} transition duration-[500ms] translate-x-[10px] -rotate-180`}
              >
                {
                  youtubeSrc ? <FaYoutube className='h-6 w-6 text-red-600' />
                    : <FcVideoCall className='h-6 w-6' />
                }
              </span>
            </Switch>
          </div>

          {/* murl */}
          <div className='flex flex-col w-full' hidden={youtubeSrc}>
            <span className="text-lg font-semibold">{required['murl']} *</span>
            {
              formData.murl && !deleted.murl ?
                <div className="relative bg-black">
                  <ReactPlayer url={formData.murl} muted loop playing width="100%" style={{ borderRadius: 20 }} />
                  <div className="absolute bg-gray-800 bg-opacity-60 tailwind-hover-opacity flex items-center justify-center inset-0 rounded-lg">
                    {
                      loading ? <span className="loading loading-ring w-20 text-lightAqua" />
                        :
                        <>
                          <button type="button" className="rounded-full text-gray-50 hover:bg-red-500 p-2"><MdDelete fontSize={30} onClick={() => { setFormData({ ...formData, murl: "" }); setDeleted({...deleted, murl: true}) }} /></button>
                          <label htmlFor="murl" className="rounded-full text-gray-50 hover:bg-blue-500 p-2 cursor-pointer"><FaEdit fontSize={30} /></label>
                        </>
                    }
                  </div>
                </div>
                :
                <label htmlFor='murl' className="upload-container">
                  {
                    loading ?
                      <span className="loading loading-ring w-20 text-lightAqua" />
                      :
                      <>
                        <FcVideoCall fontSize={120} />
                        <span>Pick a medium quality source for your video</span>
                      </>
                  }
                </label>
            }

            <input disabled={loading || youtubeSrc} type="file" accept="video/*" className="hidden" id='murl' onChange={handleUpload} />
            {
              error.murl &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.murl}
              </small>
            }
          </div>

          {/* lurl */}
          <div className='flex flex-col w-full' hidden={youtubeSrc}>
            <span className="text-lg font-semibold">{required['lurl']} *</span>
            {
              formData.lurl && !deleted.lurl ?
                <div className="relative bg-black">
                  <ReactPlayer url={formData.lurl} muted loop playing width="100%" style={{ borderRadius: 20 }} />
                  <div className="absolute bg-gray-800 bg-opacity-60 tailwind-hover-opacity flex items-center justify-center inset-0 rounded-lg">
                    {
                      loading ? <span className="loading loading-ring w-20 text-lightAqua" />
                        :
                        <>
                          <button type="button" className="rounded-full text-gray-50 hover:bg-red-500 p-2"><MdDelete fontSize={30} onClick={() => { setFormData({ ...formData, lurl: "" }); setDeleted({...deleted, lurl: true}) }} /></button>
                          <label htmlFor="lurl" className="rounded-full text-gray-50 hover:bg-blue-500 p-2 cursor-pointer"><FaEdit fontSize={30} /></label>
                        </>
                    }
                  </div>
                </div>
                :
                <label htmlFor='lurl' className="upload-container">
                  {
                    loading ?
                      <span className="loading loading-ring w-20 text-lightAqua" />
                      :
                      <>
                        <FcVideoCall fontSize={120} />
                        <span>Pick a medium quality source for your video</span>
                      </>
                  }
                </label>
            }

            <input disabled={loading || youtubeSrc} type="file" accept="video/*" className="hidden" id='lurl' onChange={handleUpload} />
            {
              error.lurl &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.lurl}
              </small>
            }
          </div>

          {/* murl youtube src */}
          <div className='flex flex-col w-full' hidden={!youtubeSrc}>
            <label htmlFor="murl" className="text-lg font-semibold">Youtube Video Source *</label>
            <input disabled={!youtubeSrc} value={vaildYoutubeLink.test(formData.murl) ? formData.murl : ""} id="murl" placeholder="youtube link to your video" type="text" className="paper-input-bar" onChange={handleChange} />
            {
              error.murl &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.murl}
              </small>
            }
          </div>

          {/* lurl youtube src */}
          {/* <div className='flex flex-col w-full' hidden={!youtubeSrc}>
            <label htmlFor="lurl" className="text-lg font-semibold">{required['lurl']} *</label>
            <input value={vaildYoutubeLink.test(formData.lurl) ? formData.lurl : ""} id="lurl" placeholder="youtube link to your video" type="text" className="paper-input-bar" onChange={handleChange} />
            {
              error.lurl &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.lurl}
              </small>
            }
          </div> */}

          <div className='flex flex-col w-full mt-2'>
            <button disabled={loading} className="submit">
              {
                loading ?
                  <span className="loading text-lightAqua" />
                  :
                  `${video ? 'Save Updates' : 'Add Video'}`
              }
            </button>
            {
              error.submit &&
              <small className='text-red-700 flex items-center gap-1'>
                <MdErrorOutline /> {error.submit}
              </small>
            }
          </div>

        </form>
      </div>
    </section>
  )
}

export default VideoForm